import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35a38490"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "no-style-export-text"
}, "Export", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_app_dropdown_item = _resolveComponent("app-dropdown-item");
  const _component_export_drop_down = _resolveComponent("export-drop-down");
  return _openBlock(), _createBlock(_component_export_drop_down, {
    arrow_icon_color: "#757575",
    isDownloadRunning: $props.isDownloadRunning
  }, {
    "button-content": _withCtx(() => [_createVNode(_component_app_icon, {
      icon: "export-content-csv"
    }), _hoisted_1]),
    body: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.export_options_categories, category => {
      return _openBlock(), _createBlock(_component_app_dropdown_item, null, {
        body: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.export_options.filter(item => item.sub_category == category), item => {
          return _openBlock(), _createBlock(_component_b_dropdown_item, {
            onClick: $event => $options.handleDownload(item)
          }, {
            default: _withCtx(() => [_createVNode(_component_flex_row, {
              class: "dropdown-row",
              styles: {
                justifyContent: 'space-between'
              },
              gap: 4
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item?.text) + " ", 1), (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                key: `download-option-${item.text}`,
                class: "icon-right"
              }))]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["onClick"]);
        }), 256))]),
        _: 2
      }, 1024);
    }), 256))]),
    _: 1
  }, 8, ["isDownloadRunning"]);
}